module.exports = __webpack_public_path__ + "static/media/BG.7518499d.png";